import styled from 'styled-components';

export const SliderBarHeader = styled.div`
  margin-bottom: ${({ theme }) => `${theme.spacing.x4}`};
`;
export const SliderBarHeaderSvg = styled.svg`
  font-size: ${({ theme }) => `${theme.fs.xxxl}`};
  color: ${({ theme }) => `${theme.palette.white}`};
`;
